/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M15.4362.0212c1.6277-.2022 3.0646 1.0673 3.0646 2.7075v1.0631a7.513 7.513 0 0 0 1.3144-.001l2.533-.2243c.8881-.0787 1.6526.6211 1.6526 1.5127L24 14.75c0 5.1086-4.1414 9.25-9.25 9.25-2.4668 0-4.7093-.9666-6.3671-2.5401-4.702-.4372-8.383-4.3937-8.383-9.2099l.0009-9.5213c0-1.6402 1.4368-2.9097 3.0645-2.7075a50.1916 50.1916 0 0 0 12.3709 0Zm7.0646 5.058L22.5 14.7656c-.0085 4.273-3.475 7.7344-7.75 7.7344-1.4696 0-2.8429-.4086-4.0137-1.1188 4.402-.7111 7.7636-4.5286 7.7636-9.1312l.0009-6.9535c.4814.035.9652.0311 1.4467-.0115l2.533-.2244a.02.02 0 0 1 .0074.0006.03.03 0 0 0 .0068.0043.0317.0317 0 0 1 .0049.0063s.0012.0029.0012.0074Zm-18.75 1.9103a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75Zm8.2499-.75a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Zm-4.5008 7.5104a.75.75 0 0 0-1.5 0c0 1.795 1.455 3.25 3.25 3.25 1.7949 0 3.25-1.455 3.25-3.25a.75.75 0 0 0-1.5 0c0 .9665-.7835 1.75-1.75 1.75s-1.75-.7835-1.75-1.75Z"
    clipRule="evenodd"
  />,
  'MenuRolesFilled'
);
